/* sp-siebdruck.js v6 (Größen als 3. Option, Druckfläche zeigen) – Produktseite Siebdruck-Beutel (Preise brutto, Preislogik A: jede Kachel = Endpreis je Stück)
   Menge × Druckfarben vorne → Beutel-Variante; Rückseite (optional) → Zusatzprodukt-Variante.
   Farbkreise wechseln das Bild; hochgeladenes Motiv wird als Vorschau auf den Beutel gelegt. */
(function () {
  var root = document.querySelector('[data-sd-pdp]');
  if (!root) return;
  var jsonEl = root.querySelector('[data-sd-json]');
  if (!jsonEl) return;
  var D;
  try { D = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  var en = root.getAttribute('data-locale') === 'en';
  var VAT = 1.19;
  var r = function (c) { return Math.round(c); };
  var fmt = new Intl.NumberFormat(en ? 'en-GB' : 'de-DE', { style: 'currency', currency: 'EUR' });
  var money = function (c) { return fmt.format(c / 100); };
  var qtyOf = function (l) { var n = parseInt(String(l).replace(/[^0-9]/g, ''), 10); return n > 0 ? n : 1; };
  var qLabel = function (l) { return en ? String(l).replace(/\./g, ',').replace('Stück', 'pcs') : l; };
  var find = function (arr, o1, o2, o3) { for (var i = 0; i < arr.length; i++) { if (arr[i].o1 === o1 && arr[i].o2 === o2 && (o3 == null || arr[i].o3 === o3)) return arr[i]; } return null; };
  var unit = function (v) { return v ? v.p / qtyOf(v.o1) : 0; }; // brutto je Stück in Cent
  var hasBack = D.back && D.back.length && D.bf && D.bf.length;
  // Kacheln: netto fett, danach brutto (14.10.2026)
  var tileP = function (g) { return '<b style="color:#111111;font-weight:700">' + money(r(g / VAT)) + ' ' + (en ? 'net' : 'netto') + '</b> · ' + money(g) + ' ' + (en ? 'gross' : 'brutto'); };

  var S = { o1: D.cur.o1, o2: D.cur.o2, o3: D.cur.o3 == null ? null : D.cur.o3, side: 'front', b: 0 };
  var SZ = D.sz && D.sz.length ? D.sz : null;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var set = function (sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); };
  var idInput = $('[data-sd-id]');
  var sideProp = $('[data-sd-side-prop]');

  var backCard = $('[data-sd-back]'), backSw = $('[data-sd-backsw]');
  if (!hasBack && backCard) backCard.hidden = true;

  function backVar(o1) { return hasBack && S.side === 'both' ? find(D.back, o1, D.bf[S.b]) : null; }

  function render() {
    var v = find(D.variants, S.o1, S.o2, S.o3);
    var bv = backVar(S.o1);
    $$('[data-sd-q]').forEach(function (b) {
      var o1 = D.q[+b.getAttribute('data-sd-q')];
      b.setAttribute('aria-pressed', o1 === S.o1 ? 'true' : 'false');
      var vv = find(D.variants, o1, S.o2, S.o3), bb = backVar(o1);
      var s = b.querySelector('[data-sd-qp]');
      if (s) s.innerHTML = vv ? tileP(r(unit(vv)) + r(unit(bb))) : '–';
    });
    $$('[data-sd-f]').forEach(function (b) {
      var o2 = D.f[+b.getAttribute('data-sd-f')];
      b.setAttribute('aria-pressed', o2 === S.o2 ? 'true' : 'false');
      var vv = find(D.variants, S.o1, o2, S.o3), s = b.querySelector('[data-sd-fp]');
      if (s) s.innerHTML = vv ? tileP(r(unit(vv)) + r(unit(bv))) : '–';
    });
    var b1 = hasBack ? find(D.back, S.o1, D.bf[0]) : null;
    $$('[data-sd-b]').forEach(function (b) {
      var i = +b.getAttribute('data-sd-b');
      b.setAttribute('aria-pressed', i === S.b ? 'true' : 'false');
      var vv = hasBack ? find(D.back, S.o1, D.bf[i]) : null, s = b.querySelector('[data-sd-bp]');
      if (s) s.innerHTML = vv && v ? tileP(r(unit(v)) + r(unit(vv))) : '–';
    });
    var both = S.side === 'both' && hasBack;
    var bo = $('[data-sd-backopt]'); if (bo) bo.hidden = !both;
    if (backCard) backCard.classList.toggle('is-off', !both);
    if (backSw) backSw.setAttribute('aria-checked', both ? 'true' : 'false');
    var ion = $('[data-sd-bagicon-on]'), ioff = $('[data-sd-bagicon-off]'); if (ion) ion.hidden = !both; if (ioff) ioff.hidden = both;
    set('[data-sd-back-sub]', both ? (v ? D.t.without + ' ' + money(r(unit(v))) + ' ' + D.t.perpc : D.t.area) : D.t.notprinted + (b1 && v ? ' · ' + D.t.withb + ' ' + money(r(unit(v)) + r(unit(b1))) + ' ' + D.t.perpc : ''));
    var bfi = $('[data-sd-file="b"]'); if (bfi) bfi.disabled = !both;
    if (sideProp) sideProp.value = both ? D.t.both + ' (' + D.t.cols[S.b] + ')' : D.t.front;
    if (!v) return;
    idInput.value = v.id;
    var gross = v.p + (bv ? bv.p : 0), tnet = r(gross / VAT);
    var uf = r(unit(v)), ub = r(unit(bv)), u = uf + ub;
    set('[data-sd-unit]', money(u));
    set('[data-sd-mbar-p]', money(u));
    set('[data-sd-brk]', bv ? D.t.brkf + ' ' + money(uf) + ' · ' + D.t.brkb + ' + ' + money(ub) + ' = ' + money(u) + ' ' + D.t.pc : D.t.brkall);
    set('[data-sd-pack]', qLabel(S.o1) + ' · ' + D.t.gross + ' ' + money(gross));
    set('[data-sd-pack-gross]', D.t.net + ' ' + money(tnet));
    set('[data-sd-net]', money(v.p));
    set('[data-sd-bnet]', money(bv ? bv.p : 0));
    set('[data-sd-tnet]', money(tnet));
    set('[data-sd-vat]', money(gross - tnet));
    set('[data-sd-gross]', money(gross));
    set('[data-sd-band-q]', qLabel(S.o1));
    set('[data-sd-band-f]', D.t.frontw + ' ' + D.t.cols[D.f.indexOf(S.o2)]);
    set('[data-sd-band-b]', bv ? D.t.backw + ' ' + D.t.cols[S.b] : D.t.backw + ' ' + D.t.nothing);
    set('[data-sd-band-p]', money(u) + ' ' + D.t.perpc);
    var l2 = $('[data-sd-l2row]'); if (l2) l2.hidden = !bv;
    set('[data-sd-l2]', D.t.backl + ', ' + D.t.cols[S.b]);
    set('[data-sd-l1]', D.t.bags + ', ' + D.t.cols[D.f.indexOf(S.o2)]);
    if (SZ) $$('[data-sd-z]').forEach(function (b) { var z = SZ[+b.getAttribute('data-sd-z')], vz = find(D.variants, S.o1, S.o2, z); b.setAttribute('aria-pressed', z === S.o3 ? 'true' : 'false'); var sp = b.querySelector('[data-sd-zp]'); if (sp) sp.innerHTML = vz ? tileP(r(unit(vz))) : '–'; });
    $$('[data-sd-heat] [data-q]').forEach(function (c) { var on = D.q[+c.getAttribute('data-q')] === S.o1 && D.f[+c.getAttribute('data-f')] === S.o2; c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); } catch (e) {}
  }

  $$('[data-sd-q]').forEach(function (b) { b.addEventListener('click', function () { S.o1 = D.q[+b.getAttribute('data-sd-q')]; render(); }); });
  $$('[data-sd-f]').forEach(function (b) { b.addEventListener('click', function () { S.o2 = D.f[+b.getAttribute('data-sd-f')]; render(); }); });
  if (backSw) backSw.addEventListener('click', function () { S.side = S.side === 'both' ? 'front' : 'both'; render(); });
  $$('[data-sd-b]').forEach(function (b) { b.addEventListener('click', function () { S.b = +b.getAttribute('data-sd-b'); render(); }); });

  // Größen (3. Option)
  function applySize() {
    if (!SZ) return;
    var info = (D.szi || {})[S.o3] || {};
    if (info.masse) set('[data-sd-masse]', info.masse);
    if (info.flaeche) { set('[data-sd-flaeche]', D.t.upto + ' ' + info.flaeche); D.t.area = D.t.upto + ' ' + info.flaeche; if (typeof setPaDims === 'function') setPaDims(info.flaeche, info.masse); }
    set('[data-sd-sz-name]', S.o3);
  }
  $$('[data-sd-z]').forEach(function (b) { b.addEventListener('click', function () { S.o3 = SZ[+b.getAttribute('data-sd-z')]; applySize(); buildHeat(); render(); }); });

  // Preis-Landkarte: Menge × Druckfarben vorne, je günstiger desto kräftiger
  var heat = $('[data-sd-heat]');
  function buildHeat() {
    if (!heat) return;
    var all = [], h = '<span></span>';
    D.f.forEach(function (o2, fi) { h += '<span class="sd-label sd-heat__h">' + D.t.cols[fi] + '</span>'; });
    D.variants.forEach(function (v) { if (S.o3 == null || v.o3 === S.o3) all.push(r(unit(v))); });
    var lo = Math.min.apply(null, all), hi = Math.max.apply(null, all), best = 0;
    D.q.forEach(function (o1, qi) {
      h += '<span class="sd-heat__q sd-body">' + qLabel(o1).replace(/St(ü|u)ck|pcs/, D.t.qshort) + '</span>';
      D.f.forEach(function (o2, fi) {
        var v = find(D.variants, o1, o2, S.o3), b0 = find(D.variants, D.q[0], o2, S.o3);
        if (!v) { h += '<span></span>'; return; }
        var u = r(unit(v)), sv = b0 ? Math.round((1 - u / r(unit(b0))) * 100) : 0; if (sv > best) best = sv;
        var a = hi > lo ? 0.12 + 0.78 * (hi - u) / (hi - lo) : 0.4;
        h += '<button type="button" class="sd-heat__c" data-q="' + qi + '" data-f="' + fi + '" style="background:rgba(120,230,208,' + a.toFixed(2) + ')"><b>' + money(u) + '</b><small>' + (sv > 0 ? '−' + sv + ' %' : D.t.entry) + '</small></button>';
      });
    });
    heat.innerHTML = h;
    var sb = $('[data-sd-save]'); if (sb && best > 0) { sb.textContent = D.t.saveupto + ' −' + best + ' % ' + D.t.perpiece; sb.hidden = false; }
    var hb = $('[data-sd-heat-back]'); if (hb && hasBack) { var bl = find(D.back, D.q[D.q.length - 1], D.bf[0]); if (bl) hb.textContent = D.t.backfrom + ' + ' + money(r(unit(bl))) + ' ' + D.t.perpiece + '.'; }
  }
  buildHeat();
  if (heat) {
    heat.addEventListener('click', function (e) {
      var c = e.target.closest('[data-q]'); if (!c) return;
      S.o1 = D.q[+c.getAttribute('data-q')]; S.o2 = D.f[+c.getAttribute('data-f')]; render();
    });
  }

  // Galerie + Farbkreise
  var mainBox = $('[data-sd-main]');
  var mainImg = mainBox ? mainBox.querySelector('img:not([data-sd-ov])') : null;
  var ov = $('[data-sd-ov]');
  var note = $('[data-sd-note]');
  var badge = mainBox ? mainBox.querySelector('[data-sp-ai-badge]') : null;
  var pa = $('[data-sd-pa]');
  var blank = false;   // zeigt gerade ein Farbbild ohne Druck
  var ovSrc = '';
  function showImg(src, alt, ai, isBlank, isPack) {
    if (!mainImg || !src) return;
    if (pa) pa.hidden = !paOn;
    mainImg.removeAttribute('srcset'); mainImg.src = src; mainImg.alt = alt || '';
    blank = !!isBlank;
    if (badge) {
      badge.hidden = !ai;
      var txt = badge.querySelector('[data-sp-ai-text]');
      if (txt && ai) txt.textContent = badge.getAttribute(ai === 'edited' ? 'data-text-edited' : 'data-text-generated');
    }
    updOverlay();
  }
  function updOverlay() {
    if (!ov || !note) return;
    var showOv = blank && !!ovSrc;
    ov.hidden = !showOv; if (showOv) ov.src = ovSrc;
    note.hidden = !blank;
    note.textContent = showOv ? D.t.preview : D.t.noprint;
  }
  // Druckfläche an den Beutel im Bild anpassen (Beutelkörper per Pixelanalyse messen)
  var paFw = 0, paFh = 0, paBw = 0, boxCache = {}, paOn = false;
  var paTog = $('[data-sd-patog]'), paHint = $('[data-sd-pa-hint]');
  if (pa) {
    paFw = parseFloat(pa.getAttribute('data-fw')) || 0; paFh = parseFloat(pa.getAttribute('data-fh')) || 0; paBw = parseFloat(pa.getAttribute('data-bw')) || 0;
  }
  function paText() {
    if (!paTog) return;
    var area = paFw + ' × ' + paFh + ' cm';
    var t = paTog.querySelector('[data-sd-patog-t]');
    if (t) t.textContent = paTog.getAttribute(paOn ? 'data-on' : 'data-off');
    paTog.setAttribute('aria-pressed', paOn ? 'true' : 'false');
    if (paHint) paHint.textContent = (paOn ? paTog.getAttribute('data-your') : paTog.getAttribute('data-upto')) + ' ' + area;
    var w = $('[data-sd-pa-w]'), h = $('[data-sd-pa-h]');
    if (w) w.textContent = paFw + ' cm'; if (h) h.textContent = paFh;
  }
  function setPaDims(fl, ms) {
    var a = /(\d+(?:[.,]\d+)?)\s*×\s*(\d+(?:[.,]\d+)?)/.exec(fl || ''), b = /(\d+(?:[.,]\d+)?)\s*×/.exec(ms || '');
    if (!pa || !a) return;
    paFw = parseFloat(a[1].replace(',', '.')); paFh = parseFloat(a[2].replace(',', '.'));
    if (b) paBw = parseFloat(b[1].replace(',', '.'));
    pa.style.aspectRatio = paFw + ' / ' + paFh;
    paText(); fitPa();
  }
  if (paTog) paTog.addEventListener('click', function () { paOn = !paOn; if (pa) pa.hidden = !paOn; paText(); fitPa(); });
  var isGym = /turnbeutel/.test(location.pathname), isDraw = /zuziehbeutel/.test(location.pathname);
  function measure(src) {
    if (boxCache[src]) return Promise.resolve(boxCache[src]);
    return fetch(src).then(function (r) { return r.blob(); }).then(function (b) { return createImageBitmap(b); }).then(function (im) {
      var N = 300, sc = N / Math.max(im.width, im.height), w = Math.round(im.width * sc), h = Math.round(im.height * sc);
      var c = document.createElement('canvas'); c.width = N; c.height = N;
      var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, N, N); x.drawImage(im, (N - w) / 2, (N - h) / 2, w, h);
      var d = x.getImageData(0, 0, N, N).data, rows = [];
      for (var y = 0; y < N; y++) { var bl = -1, br = -1, cl = -1, gap = 0; for (var i = 0; i < N; i++) { var k = (y * N + i) * 4, on = d[k] < 235 || d[k + 1] < 235 || d[k + 2] < 235; if (on) { if (cl < 0) cl = i; gap = 0; if (i - cl > br - bl) { bl = cl; br = i; } } else if (cl >= 0 && ++gap > 2) { cl = -1; gap = 0; } } if (bl >= 0) rows.push([y, bl, br]); } // längster zusammenhängender Lauf je Zeile (ohne seitliche Kordeln)
      if (rows.length < 20) return null;
      var y0 = rows[0][0], y1 = rows[rows.length - 1][0];
      var mid = rows.filter(function (a) { return a[0] > y0 + (y1 - y0) * 0.45 && a[0] < y0 + (y1 - y0) * 0.75; });
      var med = function (a) { a = a.slice().sort(function (p, q) { return p - q; }); return a[a.length >> 1]; };
      var L = med(mid.map(function (a) { return a[1]; })), R = med(mid.map(function (a) { return a[2]; })), bw = R - L;
      var body = rows.filter(function (a) { return a[2] - a[1] > bw * 0.85; });
      var box = { l: L / N, r: R / N, t: body[0][0] / N, b: body[body.length - 1][0] / N };
      var sum = 0, cnt = 0, by0 = Math.round(box.t * N + (box.b - box.t) * N * 0.15), by1 = Math.round(box.t * N + (box.b - box.t) * N * 0.3);
      for (var yy = by0; yy < by1; yy++) for (var xx = L + Math.round(bw * 0.1); xx < R - Math.round(bw * 0.1); xx += 2) { var kk = (yy * N + xx) * 4; sum += (d[kk] * 0.3 + d[kk + 1] * 0.59 + d[kk + 2] * 0.11); cnt++; }
      box.dark = cnt ? sum / cnt < 110 : false;
      boxCache[src] = box; return box;
    }).catch(function () { return null; });
  }
  function fitPa() {
    if (!pa || !mainImg || !paFw || !paFh || !paBw) return;
    var src = mainImg.currentSrc || mainImg.src;
    measure(src).then(function (box) {
      if (!box || (mainImg.currentSrc || mainImg.src) !== src) return;
      var bw = box.r - box.l, w = bw * paFw / paBw, h = w * paFh / paFw;
      var cy = box.t + (box.b - box.t) * (isDraw ? 0.6 : isGym ? 0.5 : 0.47), cx = (box.l + box.r) / 2;
      if (w <= 0 || w > 0.9) return;
      pa.style.left = ((cx - w / 2) * 100).toFixed(1) + '%';
      pa.style.top = ((cy - h / 2) * 100).toFixed(1) + '%';
      pa.style.width = (w * 100).toFixed(1) + '%';
      pa.classList.toggle('is-dark', !!box.dark);
      if (mainBox) { mainBox.style.setProperty('--ov-top', (cy * 100).toFixed(1) + '%'); mainBox.style.setProperty('--ov-w', (w * 90).toFixed(1) + '%'); }
      if (ov) ov.style.maxHeight = (h * 90).toFixed(1) + '%';
    });
  }
  if (mainImg) { mainImg.addEventListener('load', fitPa); if (mainImg.complete) fitPa(); }

  $$('[data-sd-thumb]').forEach(function (t, ti) {
    t.addEventListener('click', function () {
      $$('[data-sd-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      showImg(t.getAttribute('data-src'), t.getAttribute('data-alt'), t.getAttribute('data-ai'), false, ti === 0 && !t.getAttribute('data-ai'));
    });
  });
  var bagInput = $('[data-sd-bag]');
  var bagName = $('[data-sd-bag-name]');
  var curSw = null;
  $$('[data-sd-sw]').forEach(function (b, i) {
    if (i === 0) curSw = b;
    b.addEventListener('click', function () {
      curSw = b;
      $$('[data-sd-sw]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var n = b.getAttribute('data-sd-sw');
      if (bagInput) bagInput.value = n;
      if (bagName) bagName.textContent = n;
      var src = b.getAttribute('data-img');
      if (src) {
        $$('[data-sd-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        var aiSw = /ki-generiert|ai-generated/i.test(src) ? 'generated' : (/ki-bearbeitet|ai-edited/i.test(src) ? 'edited' : '');
        showImg(src, D.title + ' – ' + n, aiSw, true);
      }
    });
  });

  // Uploads
  var later = $('[data-sd-later]');
  var msg = $('[data-sd-msg]');
  function clearMsg() { if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); } }
  $$('[data-sd-file]').forEach(function (inp) {
    var k = inp.getAttribute('data-sd-file');
    var upl = $('[data-sd-upl="' + k + '"]'), fname = $('[data-sd-file-name="' + k + '"]');
    fname.setAttribute('data-def', fname.textContent);
    inp.addEventListener('change', function () {
      var f = inp.files && inp.files[0];
      upl.classList.toggle('has-file', !!f);
      fname.textContent = f ? f.name : fname.getAttribute('data-def');
      if (f && later) later.checked = false;
      clearMsg();
      if (k === 'f') {
        ovSrc = '';
        if (f && /^image\/(png|jpe?g|svg\+xml|webp|gif)$/.test(f.type)) {
          ovSrc = URL.createObjectURL(f);
          if (!blank && curSw && curSw.getAttribute('data-img')) curSw.click(); else updOverlay();
        } else updOverlay();
      }
    });
  });
  if (later) later.addEventListener('change', function () {
    if (later.checked) $$('[data-sd-file]').forEach(function (inp) {
      var k = inp.getAttribute('data-sd-file');
      inp.value = ''; $('[data-sd-upl="' + k + '"]').classList.remove('has-file'); var fn = $('[data-sd-file-name="' + k + '"]'); fn.textContent = fn.getAttribute('data-def') || D.t.upload;
    });
    ovSrc = ''; updOverlay(); clearMsg();
  });

  // Absenden
  var form = document.getElementById('sd-form');
  var busy = false;
  if (form) form.addEventListener('submit', function (e) {
    var ff = $('[data-sd-file="f"]'), fb = $('[data-sd-file="b"]');
    var hasF = ff && ff.files && ff.files.length, hasB = fb && !fb.disabled && fb.files && fb.files.length;
    var both = S.side === 'both' && hasBack;
    var ok = (later && later.checked) || (hasF && (!both || hasB));
    if (!ok) {
      e.preventDefault();
      if (msg) { msg.textContent = D.t.need; msg.classList.add('is-error'); }
      var up = $('[data-sd-upl="f"]'); if (up) up.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (ff && !hasF) ff.disabled = true;
    if (fb && !hasB) fb.disabled = true;
    if (!both) return; // normaler Formular-Versand
    e.preventDefault();
    if (busy) return; busy = true;
    var bv = backVar(S.o1);
    var fd = new FormData(form);
    var props = {}; props[D.t.forbag] = D.title + (bagInput ? ' · ' + bagInput.value : '');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('main'); return r.json(); })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: bv.id, quantity: 1, properties: props }] }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('back'); window.location.href = D.cart || '/cart'; })
      .catch(function () {
        busy = false;
        if (ff) ff.disabled = false; render();
        if (msg) { msg.textContent = D.t.err; msg.classList.add('is-error'); }
      });
  });

  render();
})();
